/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The IdLongModel model module.
 * @module model/IdLongModel
 * @version v1.0.0
 */
class IdLongModel {
    /**
     * Constructs a new <code>IdLongModel</code>.
     * @alias module:model/IdLongModel
     */
    constructor() { 
        
        IdLongModel.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>IdLongModel</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/IdLongModel} obj Optional instance to populate.
     * @return {module:model/IdLongModel} The populated <code>IdLongModel</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new IdLongModel();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} id
 */
IdLongModel.prototype['id'] = undefined;






export default IdLongModel;

